import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, framework } from "./adapter-vue";
import { TUILogin } from "@tencentcloud/tui-core";
import {
  TUIStore,
  StoreName,
  TUIConversationService,
  TUITranslateService,
} from "@tencentcloud/chat-uikit-engine";
import {
  TUISearch,
  TUIConversation,
  TUIChat,
  TUIContact,
  TUIGroup,
} from "./components";
import { isH5 } from "./utils/env";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  // When deploying a production environment, you do not need to pass in SDKAppID, userID, and userSig through props.
  // eslint-disable-next-line vue/prop-name-casing
  SDKAppID: {
    type: Number,
    default: 0,
    required: false,
  },
  userID: {
    type: String,
    default: "",
    required: false,
  },
  userSig: {
    type: String,
    default: "",
    required: false,
  },
  conversationID: {
    type: String,
    default: "",
    required: false, // When integrating Chat independently, you need to pass the conversationID
  },
},
  setup(__props) {

const props = __props

const currentConversationID = ref<string>("");
const currentNavbar = ref<string>("message");
const currentLanguage = ref<string>("zh");
const navbarList = [
  {
    id: "message",
    label: "消息",
  },
  {
    id: "contact",
    label: "通讯录",
  },
];



onMounted(() => {
  TUIStore.watch(StoreName.CONV, {
    currentConversationID: (id: string) => {
      currentConversationID.value = id;
    },
  });

  // Default login logic
  login();

  // init language by SDKAppID
  initLanguage();

  // Modify CallKit style in H5 environment
  modifyCallKitStyle();
});

function login() {
  const { SDKAppID, userID, userSig, conversationID } = props;
  if (SDKAppID && userID && userSig) {
    TUILogin.login({
      SDKAppID,
      userID,
      userSig,
      useUploadPlugin: true,
      framework,
    })
      .then(() => {
        // Execute the following code when integrating Chat independently
        if (
          conversationID.startsWith("C2C") ||
          conversationID.startsWith("GROUP")
        ) {
          TUIConversationService.switchConversation(conversationID);
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
      })
      .catch((error) => {});
  }
}

function isIntlSDKAppID(SDKAppID: number) {
  if (
    SDKAppID === 0 ||
    (SDKAppID >= 20000000 && SDKAppID < 90000000) ||
    (SDKAppID >= 1720000000 && SDKAppID < 1790000000)
  ) {
    return true;
  }
  return false;
}

function initLanguage() {
  currentLanguage.value = isIntlSDKAppID(props.SDKAppID) ? "en" : "zh";
  TUITranslateService.changeLanguage(currentLanguage.value);
}

function modifyCallKitStyle() {
  if (isH5) {
    const bodyStyle = document.getElementsByTagName("body")[0].style;
    bodyStyle.setProperty("--callLeft", "0");
    bodyStyle.setProperty("--callTop", "0");
    bodyStyle.setProperty("--callWidth", "100%");
    bodyStyle.setProperty("--callHeight", "100%");
  }
}

return { __sfc: true,currentConversationID, currentNavbar, currentLanguage, navbarList, props, login, isIntlSDKAppID, initLanguage, modifyCallKitStyle, TUITranslateService, TUISearch, TUIConversation, TUIChat, TUIContact, TUIGroup, isH5 }
}

})